
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/support-programs",
      function () {
        return require("private-next-pages/support-programs/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/support-programs"])
      });
    }
  